<template>
    <ui-modal
        icon="fal fa-user-graduate"
        name="instructions"
        title="Gerador de Documentos e Contratos - Instruções de uso"
        size="sm"
    >
        <section class="modal-content-line">
            <h2>1 - Prepare o seu documento no Microsoft Word</h2>
            <p>
                Aproveite o seus contratos já existentes e altere-os substituindo os
                valores que comumente são dinâmicos pelas macros Facilita.
            </p>
            <div class="flex-column">
                <div class="flex-elements">
                    <h2>Macros Disponíveis:</h2>
                    <ui-button type="submit" design="lg primary" @click="PrintElem()">
                        {{ printBtnText }} <i class="fal fa-print" />
                    </ui-button>
                </div>

                <div class="flex-elements">
                    <h2>Como Utilizar as Macros:</h2>
                    <a href="https://cdn.appfacilita.com/companies/goscore/contracts/comoutilizarmacros.pdf" target="_blank">
                        <ui-button type="submit" design="lg primary">
                            Baixar Instruçoes <i class="fal fa-file-pdf"/>
                        </ui-button>
                    </a>
                </div>
            </div>
            <br />      
        </section>
        <section class="modal-content-line">
            <h2>2 - Envie o seu contrato para o Facilita</h2>
            <p>
                Agora basta enviar o seu contrato para o Facilita e definir para quais empreendimentos, 
                etapas e status do funil de vendas o seu contrato deve ser apresentado para o corretor.
            </p>
        </section>
        <section class="modal-content-line">
            <p>
                Para maiores informações clique aqui:
                <a href="https://suporte.appfacilita.com/hc/pt-br" target="_blank">suporte.appfacilita.com</a>
            </p>
        </section>
    </ui-modal>
</template>

<script>
import { contractGeneration }       from "@/services/axios";
import { uiButton }                 from "@/components/ui/buttons";
import { uiModal }                  from "@/components/ui/modal";
import { storage }                  from "@/services/storage";

export default {
  name: "modal-instruction",
  components: { uiButton, uiModal},
  data() {
    return {
      printBtnText: "Imprimir Macros",
      instance: null,
      macrosArray: [],
      macrosKeys: [],
      ObjMacro: {},
      script: "",
    };
  },
  created() {
    let api_config = storage.get("api_config");
    api_config = JSON.parse(api_config);
    this.instance = api_config.instance;
    this.getMacros();
  },
  methods: {
    PrintElem() {

      /* Instancia a janela */
      let printWindow = window.open("", "Imprimir");

      printWindow.document.write(
        `<html>
          <head>
            <title>${document.title}</title>
          </head>
        `
      );
      printWindow.document.write("<body>");
      printWindow.document.write(`
        <style>
          .print-h1{
            text-align: center;
            font-weight: 500;
            margin-bottom: 0.5rem;
            font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, 
            "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", 
            "Segoe UI Symbol", "Noto Color Emoji";
            font-size: 2.5em;
            color: 2D93F8;
            margin-bottom: 18px;
          }

          .print-macros, span{
            font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, 
            "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", 
            "Segoe UI Symbol", "Noto Color Emoji";
            font-size: 15px
          }
        
        </style>
      `);
      printWindow.document.write("<div style='text-align: center;'>");
      printWindow.document.write(`<h1 class="print-h1">Dados do Negócio</h1>`);
      this.ObjMacro.map((item) => {
        printWindow.document.write(
          `<div><span>${this.macroTranslate[item[0]]}</span> | <span>\u0024\u007B${item[1]}\u007D</span></div><br>`
        );
      });
      this.macrosArray.map((item, index) => {
        printWindow.document.write(`<h1 class="print-h1">${this.macrosKeys[index]}</h1>`);
        
        let macrosList = this.returnMacroName(item);
        let macroItem = Object.entries(macrosList);
        macroItem.map((macroName) => {
          printWindow.document.write(
            `<div><span>${macroName[1]}</span> | <span>\u0024\u007B${macroName[1]}\u007D</span></div><br>`
          );
        });
      });
      printWindow.document.write("</div>");
      printWindow.document.write("</body></html>");

      printWindow.focus();
      printWindow.print();
      return true;
    },
    returnMacroName(macro) {
      let macroKeys = Object.entries(macro);
      return macroKeys[0][1];
    },
    getMacros() {
      contractGeneration.getAll("/variables").then((response) => {
        if (response.data.status === "error") return Promise.reject(response);

        let data = response["data"].macros;
        let translate = response["data"].translate;
        let macroReferenceNames = [];
        let macro = [];
        let ObjMacro = {};

        Object.keys(data).map(function (key) {
          if (typeof data[key] != "object") {
            ObjMacro[key] = data[key];
            delete data[key];
          } else {
            macro.push({
              [translate[key]]: data[key],
            });
          }
        });

        macro.map(function (key) {
          macroReferenceNames.push(Object.keys(key)[0]);
        });
        this.macrosArray = macro;
        this.macrosKeys = macroReferenceNames;
        this.macroTranslate = translate;
        this.ObjMacro = Object.entries(ObjMacro);
      });
    },
    copyText() {
      this.$refs.code.select();
      document.execCommand("copy");
      this.copyBtnText = "Copiado com sucesso!";
      let t = setInterval(() => {
        this.copyBtnText = "Copiar";
        clearInterval(t);
        document.getSelection().removeAllRanges();
      }, 1000);
    },
    getInstance() {},
  },
};
</script>

<style lang="stylus" scoped>
  @import './styles.styl';
</style>